import { useMemo } from 'react';
import { ClassNamesConfig, OptionProps } from 'react-select';
import { useClassNamesWithStyle } from '@edikk-edikk/country-frontend';
import cityChooserCss from '#components/city-chooser/assets/city-chooser.module.scss';

const useCityChooserClassNames = (classNames: ClassNamesConfig|undefined): ClassNamesConfig => {
  const classNamesWithStyle = useClassNamesWithStyle();

  return useMemo(() => {
    const classNamesDefault = {
      container: () => cityChooserCss.cityChooser__container,
      option: (state: OptionProps): string => classNamesWithStyle(
        [
          cityChooserCss.cityChooser__option,
          { [cityChooserCss.cityChooser__option_focused]: state.isFocused },
          { [cityChooserCss.cityChooser__option_selected]: state.isSelected },
        ],
        cityChooserCss.cityChooser__option_styleDefault,
        cityChooserCss.cityChooser__option_styleRed,
      ),
    };

    if (classNames) {
      return { ...classNamesDefault, ...classNames };
    }

    return classNamesDefault;
  }, [classNames, classNamesWithStyle]);
};

export { useCityChooserClassNames };
